(function () {
var $8c54fc3050bb59d0$exports = {};
(()=>{
    function bindAll() {
        const _bg = document.getElementById("whatif__bg");
        const _content = document.querySelector(".whatif__content__wrapper");
        const _carousel = document.querySelector(".whatif__carousel");
        const _dialog = document.getElementById("dialog");
        const _dialogscrollbar = document.getElementById("dialog__scroll");
        let BGFX_timer;
        document.querySelectorAll(".whatif__carousel__image").forEach((day, i)=>{
            const num = parseInt(day.dataset.num);
            if (window["DayImg" + num]) window["DayImg" + num]();
            day.addEventListener("click", ()=>{
                if (window["Day" + num]) {
                    window["Day" + num]();
                    window.scrollTo(0, 0);
                    _bg.classList.add("darken");
                    _content.classList.add("disable");
                    _carousel.classList.add("disable");
                    document.querySelector("body").classList.add("freeze");
                    clearInterval(BGFX_timer);
                    _dialog.classList.add("show");
                    _dialogscrollbar.scrollTo(0, 0);
                }
            });
        });
        document.getElementById("dialog__closebtn").addEventListener("click", (event)=>{
            // Stops Spotify on close.
            if (document.querySelector('iframe[src*="spotify.com/embed"]')) {
                const spotifyEmbedWindow = document.querySelector('iframe[src*="spotify.com/embed"]').contentWindow;
                spotifyEmbedWindow.postMessage({
                    command: "pause"
                }, "*");
            }
            // Stops Videos on close.
            if (document.querySelector("iframe, video")) {
                var videos = document.querySelectorAll("iframe, video");
                Array.prototype.forEach.call(videos, function(video) {
                    if (video.tagName.toLowerCase() === "video") video.pause();
                    else {
                        var src = video.src;
                        video.src = src;
                    }
                });
            }
            _bg.classList.remove("darken");
            _content.classList.remove("disable");
            _carousel.classList.remove("disable");
            _dialog.classList.remove("show");
            document.querySelector("body").classList.remove("freeze");
            startBGFX();
        });
        const startBGFX = ()=>{
            const bgFXimgs = document.querySelectorAll(".bgFX img");
            const bgFXimgsCount = bgFXimgs.length - 1;
            let curFrame = 1;
            let prevFrame;
            let dir = 1;
            BGFX_timer = setInterval(()=>{
                // Loop with reversal
                if (curFrame === bgFXimgsCount || curFrame === 0) dir = dir * -1;
                curFrame += dir;
                bgFXimgs[curFrame].classList.add("show");
                if (prevFrame !== undefined) bgFXimgs[prevFrame].classList.remove("show");
                prevFrame = curFrame;
            }, 65);
        };
        startBGFX();
    }
    /**
   * Creates a timeout before setting all the JS to the DOM 
   */ // Initializer function.
    const _init = ()=>{
        window["_satellite"] = window["_satellite"] || {};
        window["digitalData"] = window["digitalData"] || {};
        setTimeout(()=>{
            bindAll();
        }, 1000);
    };
    // Wait for DOM content loaded.
    document.addEventListener("DOMContentLoaded", _init);
})();

})();
//# sourceMappingURL=index.55049926.js.map
